import React from 'react';
import PropTypes from 'prop-types';

import Strings from '../../Strings';
import './SelectionBar.scss';

/**
 * bar shown above a table while rows are selected, holds the bulk actions for the selection
 *
 * example
 * <SelectionBar show={count > 0} title="3 patients selected" onClear={clear}>
 *   <SelectionBarButton primary icon="archive" onClick={archive}>Archive</SelectionBarButton>
 * </SelectionBar>
 */
export function SelectionBar({ show, title, subtitle, onClear, children }) {
  if (!show) {
    return null;
  }

  return (
    <div className="selection-bar" role="region" aria-label={Strings.selectedItems} data-testid="selection-bar">
      <span className="selection-bar-title" aria-live="polite">
        {title}
      </span>
      {subtitle && <span className="selection-bar-subtitle">{subtitle}</span>}
      <span className="selection-bar-spacer" />
      {children}
      {onClear && (
        <SelectionBarButton onClick={onClear} testId="selection-bar-clear">
          {Strings.clear}
        </SelectionBarButton>
      )}
    </div>
  );
}

SelectionBar.propTypes = {
  show: PropTypes.bool,
  title: PropTypes.node,
  subtitle: PropTypes.node,
  onClear: PropTypes.func,
  children: PropTypes.node,
};

export function SelectionBarButton({ primary, icon, disabled, onClick, testId, children }) {
  return (
    <button
      type="button"
      className={`selection-bar-button ${primary ? 'primary' : 'ghost'}`}
      disabled={disabled}
      onClick={onClick}
      data-testid={testId}
    >
      {icon && <span className={`selection-bar-icon ${icon}`} aria-hidden="true" />}
      {children}
    </button>
  );
}

SelectionBarButton.propTypes = {
  primary: PropTypes.bool,
  icon: PropTypes.string,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  testId: PropTypes.string,
  children: PropTypes.node,
};
